<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="500"
  >
    <v-card v-if="point !== undefined">
      <v-card-title class="mb-2">Edit point</v-card-title>
      <v-card-text class="pt-1">
        <v-row>
          <v-col cols="12" sm="8">
            <v-text-field
              :disabled="loading"
              v-model="point.label"
              label="Label"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="4">
            <v-select
              :items="icons"
              :disabled="loading"
              v-model="point.icon"
              label="Point icon"
              item-text="name"
              item-value="icon"
            ></v-select>
          </v-col>
          <v-col cols="12" :sm="point.on_click.action === '' ? 12 : 4">
            <v-select
              :items="[
                { name: 'No action', action: '' },
                { name: 'Open URL', action: 'go_url' },
                { name: 'Open scene', action: 'go_scene' }
              ]"
              :disabled="loading"
              v-model="point.on_click.action"
              label="On click event"
              item-text="name"
              item-value="action"
            ></v-select>
          </v-col>
          <v-col v-if="point.on_click.action === 'go_scene'" cols="12" sm="8">
            <v-select
              :items="scenes"
              :disabled="loading"
              v-model="point.on_click.value"
              label="Open scene"
              item-text="name"
              item-value="id"
            ></v-select>
          </v-col>
          <v-col v-if="point.on_click.action === 'go_url'" cols="12" sm="8">
            <v-text-field
              :disabled="loading"
              v-model="point.on_click.value"
              label="URL"
              required
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-btn
          color="red darken-1"
          text
          @click="remove">Remove</v-btn>
        <v-spacer></v-spacer>
        <v-btn
          color="darken-1"
          text
          @click="cancel">Cancel</v-btn>
        <v-btn
          color="green darken-1"
          text
          @click="save">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'PointDialog',
  props: {
    scenes: Array
  },
  data: () => ({
    loading: false,
    point: undefined,
    dialog: false,
    resolve: null,
    reject: null,
    icons: [
      { name: 'Dot', icon: 'dot' },
      { name: 'Plus', icon: 'plus' },
      { name: 'Arrow', icon: 'arrow' },
      { name: 'Question', icon: 'question' }
    ]
  }),
  methods: {
    open (point) {
      this.dialog = true
      this.point = { ...point }
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    save () {
      this.resolve(this.point)
      this.dialog = false
    },
    cancel () {
      this.resolve('cancel')
      this.dialog = false
    },
    remove () {
      this.resolve('remove')
      this.dialog = false
    }
  }
}
</script>

<style scoped lang="scss">

</style>
